import './index.scss'
$(".section").on('click','li',function() {
    if($(this).hasClass("active")) {
        $(".select").slideUp();
        $(this).removeClass("active")
    }else {
        $(this).addClass("active").siblings().removeClass("active");
        $(".select").slideUp();
        $(this).find(".select").slideDown();
    }
})